module.exports = __webpack_public_path__ + "img/home-grid-info-g-cleaner.19140023.png";